import { type PropsWithChildren } from 'react';

import { Box, Button, Heading2, Text } from '@ui';

import * as css from './Form.css';

type FormProps = {
    title: string;
    subtitle?: string;
    actionText: string;
    onSubmit(): void;
    isSubmitting?: boolean;
    error?: string;
};

const Form = ({
    title,
    subtitle,
    actionText,
    onSubmit,
    isSubmitting = false,
    error,
    children,
}: PropsWithChildren<FormProps>) => {
    return (
        <form onSubmit={onSubmit}>
            <Box className={css.formContainer}>
                <Heading2>{title}</Heading2>
                {subtitle && <Text>{subtitle}</Text>}
                {error && (
                    <Box className={css.error}>
                        <Text>{error}</Text>
                    </Box>
                )}
                {children}
                <Button type="submit" isLoading={isSubmitting}>
                    {actionText}
                </Button>
            </Box>
        </form>
    );
};

export default Form;
